import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    somatometria: [],
  },

  getters: {
    getSomatometria: (state) => state.somatometria,
  },

  mutations: {
    SET_SOMATOMETRIA(state, somatometria) {
      state.somatometria = somatometria;
    },
  },

  actions: {
    async fetchSomatometria({ commit }, idHistoriaClinica) {
      await axios
        .get(`PoliciaCuadrantes/C3/historiaClinica/${idHistoriaClinica}/somatometria`)
        .then((response) => {
          commit('SET_SOMATOMETRIA', response.data.data);
        });
    },

    async saveSomatometria(context, somatometria) {
      const { idHistoriaClinica } = context.rootState.historiaClinica;
      await axios
        .post(`PoliciaCuadrantes/C3/historiaClinica/${idHistoriaClinica}/somatometria`, somatometria)
        .then(() => {});
    },

    async updateSomatometria(_, somatometria) {
      await axios
        .put(
          `PoliciaCuadrantes/C3/historiaClinica/${somatometria.fk_idHistoriaClinica}/somatometria/${somatometria.fk_idSomatometria}`,
          somatometria,
        );
    },
  },
};
